
<div class="app-menu navbar-menu">
  <!-- Logo -->
  <div class="navbar-brand-box">
    <!-- Dark Logo-->
    <a routerLink="/" class="logo logo-dark">
      <span class="logo-sm">
        <img src="assets/images/SureSIM-SS-Logo-Dark-100.png" alt="" height="45">
      </span>
      <span class="logo-lg">
        <img src="assets/images/SureSIM-Logo-Dark-400.png" alt="" height="45">
      </span>
    </a>
    <!-- Light Logo-->
    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/SureSIM-Logo-Light-109.png" alt="" height="45">
      </span>
      <span class="logo-lg">
        <img
          alt=""
          [class.logo-grow-in]="sureSimLogoGrow"
          [height]="isPlatformModeInview ? 45 : 45"
          [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right.png' : 'assets/images/SureSIM-Logo-Light-400.png'"
        >
      </span>
    </a>
    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 70px)">
        <ul class="metismenu list-unstyled navbar-nav" id="navbar-nav">
          @for(item of menuItems; track $index){
            @if(item.visible) {
              @if(item.isTitle){
              <li class="menu-title"><span data-key="t-menu">{{ item.label | translate }}</span></li>
              }@else {
              <li class="nav-item">
                @if(hasItems(item)){
                <a class="is-parent nav-link menu-link" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}" data-bs-toggle="collapse" [attr.aria-expanded]="!item.isCollapsed" (click)="toggleItem(item)">
                  <!-- <i class="{{ item.icon }} icon nav-icon" class=""></i> -->
                   @if(item.icon) {
                     @if(isImageIcon(item.icon)) {
                       <img
                         [src]="normaliseIconPath(item.icon)"
                         class="icon nav-icon menu-icon-img"
                         alt=""
                       >
                     } @else {
                       <i class="{{ item.icon }} icon nav-icon" class=""></i>
                     }
                   }
                  <span class=""> {{ item.label | translate }}</span>
                  @if(item.badge){<span class="badge badge-pill {{item.badge.variant}}">{{item.badge.text
                    | translate}}</span>}
                </a>

                <div class="collapse menu-dropdown" #collapse="ngbCollapse" [(ngbCollapse)]="item.isCollapsed">
                  <ul class="nav nav-sm flex-column" aria-expanded="false">
                    @for(subitem of item.subItems; track $index){
                      @if(subitem.visible) {
                        @if(subitem.separatorBefore) {
                          <li class="menu-separator" role="separator"></li>
                        }
                        <li class="nav-item">
                          @if(hasItems(subitem)){
                          <a class="nav-link" [attr.data-parent]="subitem.parentId" data-bs-toggle="collapse" [attr.aria-expanded]="!subitem.isCollapsed" (click)="toggleItem(subitem)">
                            {{ subitem.label | translate}}
                            @if(subitem.badge){<span class="badge badge-pill {{subitem.badge.variant}}">{{subitem.badge.text
                              | translate}}</span>}
                          </a>

                          <div class="collapse menu-dropdown sub-menu" #collapse="ngbCollapse" [(ngbCollapse)]="subitem.isCollapsed">
                            <ul class="nav nav-sm flex-column" aria-expanded="false">
                              @for(subSubitem of subitem.subItems; track $index){
                                @if(subSubitem.visible) {
                                  <li class="nav-item">
                                    @if(hasItems(subSubitem)){
                                    <a class="nav-link" [attr.data-parent]="subSubitem.parentId" data-bs-toggle="collapse" [attr.aria-expanded]="!subSubitem.isCollapsed" (click)="toggleItem(subSubitem)">
                                      {{ subSubitem.label | translate}}
                                      @if(subSubitem.badge){<span class="badge badge-pill {{subSubitem.badge.variant}}">{{subSubitem.badge.text
                                        | translate}}</span>}
                                    </a>

                                    <div class="collapse menu-dropdown extra-sub-menu" #collapse="ngbCollapse" [(ngbCollapse)]="subSubitem.isCollapsed">
                                      <ul class="nav nav-sm flex-column" aria-expanded="false">
                                        @for(subSubitem1 of subSubitem.subItems; track $index){
                                        <li class="nav-item">
                                          <a [attr.data-parent]="subSubitem1.parentId" [routerLink]="subSubitem1.link" class="nav-link" (click)="updateActive($event)">
                                            {{ subSubitem1.label | translate }}
                                          </a>

                                        </li>
                                        }
                                      </ul>
                                    </div>
                                    }@else {
                                    <a [routerLink]="subSubitem.link" class="nav-link" [attr.data-parent]="subSubitem.parentId" (click)="updateActive($event)">
                                      {{ subSubitem.label | translate}}
                                      @if(subSubitem.badge){<span class="badge badge-pill {{subSubitem.badge.variant}}">{{subSubitem.badge.text
                                        | translate}}</span>}
                                    </a>
                                    }
                                  </li>
                                }
                              }
                            </ul>
                          </div>
                          }@else {
                          <a [routerLink]="subitem.link" class="nav-link" [attr.data-parent]="subitem.parentId" (click)="updateActive($event)">
                            {{ subitem.label | translate}}
                            @if(subitem.badge){<span class="badge badge-pill {{subitem.badge.variant}}">{{subitem.badge.text
                              | translate}}</span>}
                          </a>
                          }
                        </li>
                        @if(subitem.separatorAfter) {
                          <li class="menu-separator" role="separator"></li>
                        }
                      }
                    }
                  </ul>
                </div>
                }@else {
                <a
                  [routerLink]="item.link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  class="side-nav-link-ref nav-link menu-link"
                >
                  <!-- @if(item.icon){<i class="bx {{ item.icon }} icon nav-icon" class=""></i>} -->
                  @if(item.icon) {
                    @if(isImageIcon(item.icon)) {
                      <img
                        [src]="normaliseIconPath(item.icon)"
                        class="icon nav-icon menu-icon-img"
                        alt=""
                      >
                    } @else {
                      <i class="bx {{ item.icon }} icon nav-icon" class=""></i>
                    }
                  }
                    <span class=""> {{ item.label | translate }} </span>
                  @if(item.badge){
                    <span class="badge {{item.badge.variant}} float-end">{{item.badge.text | translate}}</span>}
                </a>
                }
              </li>
              }
            }
          }
        </ul>
      </ngx-simplebar>
    </div>
  </div>
  <div class="sidebar-background"></div>
</div>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="onCompanyFormCancelled()" 
  (sureSimCompanyDataHasBeenSaved)="onCompanyDataSaved($event)">
</app-company-modal-form>

<app-manage-esim-modal-form #manageEsimModalForm 
  (eSimManagerFormCancelled)="onIccidFormCancelled()" 
  (orderDataHasBeenSaved)="onIccidFormSaved()">
</app-manage-esim-modal-form>

<app-warning-modal-nr-form #warningModalForm>
</app-warning-modal-nr-form>

<div class="vertical-overlay" (click)="SidebarHide()"></div>
